import {postFile} from "../../js/axios";

export default {
    name:'resultUpload',
    data () {
        return {
            // data for upload files
            fileList:[],
            uploadFilename: null,
            uploadFiles: [],
            dialogVisible: false
        }
    },
    methods: {
        loadJsonFromFile (file, fileList) {
            this.uploadFilename = file.name;
            this.uploadFiles = fileList;
        },
        submitUpload () {
            this.$refs.upload.submit();
            console.log(this.uploadFiles);
            if (this.uploadFiles) {
                for (let i = 0; i < this.uploadFiles.length; i++) {
                    let file = this.uploadFiles[i]
                    console.log(file.raw)
                    postFile(file.raw).then( res => {
                        if(res.status == 1){
                            console.log(res)
                        }
                    })
                }

            }
        }
    }
}